import classNames from 'classnames'
import { h, JSX } from 'preact'

import { ArrowDownIcon } from '../../icon/icon'

export interface SelectOption {
    value: string
    name: string
}

export interface SelectProps {
    modifier?: string
    class?: string
    id?: string
    name?: string
    label?: string
    default?: string
    options: SelectOption[]
    value: string
    onChange: (value: string) => unknown
    isDisabled?: boolean
    attributes?: JSX.HTMLAttributes<HTMLSelectElement>
}

export const Select = (props: SelectProps): JSX.Element => (
    <div class={classNames('select', props.modifier, props.class)}>
        <div class="select__container">
            <label class="select__label" for={props.id}>
                {props.label}
            </label>
            <select
                class="select__dropdown"
                name={props.name}
                id={props.id}
                value={props.value}
                onChange={(event) => props.onChange(event.currentTarget.value)}
                disabled={props.isDisabled}
                {...props.attributes}
            >
                {props.default && (
                    <option disabled value="">
                        {props.default}
                    </option>
                )}
                {props.options.map((option: SelectOption) => (
                    <option key={option.value} value={option.value}>
                        {option.name}
                    </option>
                ))}
            </select>
            <ArrowDownIcon class="select__arrow" />
        </div>
    </div>
)
